export default __webpack_public_path__ + "static/media/unitedKingdom.d7225e95.svg";